import { useRouter } from 'next/router';

export const useQueryParam = name => {
  const router = useRouter();
  const queryParam = router.query[name] || null;

  return queryParam;
};
